import React from 'react';
import Section from '../components/Section';
import SectionTitle from '../components/SectionTitle';
import Reveal from '../components/Reveal';
import ServiceCard from './ServiceCard';
import { useServices, useHomeSections } from '../data';

// §7.1.3 — "Our Services" centered block + 3 cards.
export default function ServicesSection() {
  const services = useServices().slice().sort((a, b) => a.order - b.order);
  const sections = useHomeSections();
  return (
    <Section id="services" className="services">
      <SectionTitle white={sections.servicesTitleWhite} accent={sections.servicesTitleAccent} />
      <p className="services__intro">{sections.servicesIntro}</p>
      <div className="services__grid">
        {services.map((s, i) => (
          <Reveal key={s.id} delay={i * 120}>
            <ServiceCard service={s} index={i} />
          </Reveal>
        ))}
      </div>
    </Section>
  );
}
